import DirectSaleLGPDTermModal from '@/components/Movements/DirectSale/DirectSaleLGPDTermModal';
import { useDirectSale } from '@/core/domain/sales/DirectSale/DirectSale.hooks';
import { DirectSale } from '@/core/domain/sales/DirectSale/DirectSale.types';
import { useDisclosure } from '@/hooks';
import { PropsWithChildren, createContext, useContext, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';

interface DirectSaleContextProps {
  directSale?: DirectSale;
  isFetching: boolean;
  directSaleId: string;
  isAlerted: boolean;
  isLoading: boolean;
}

type Props = PropsWithChildren<unknown>;

const DirectSaleContext = createContext({} as DirectSaleContextProps);

export const useDirectSaleContext = () => useContext(DirectSaleContext);

export default function DirectSaleProvider({ children }: Props) {
  const { directSaleId } = useRouteMatch<{ directSaleId: string }>().params;
  const [lgpdOpen, setLgpdOpen] = useDisclosure(true);
  const [isAlerted, setIsAlert] = useState<boolean>(false);

  const {
    data: directSale,
    isFetching,
    isLoading,
  } = useDirectSale(Number(directSaleId));

  return (
    <DirectSaleContext.Provider
      value={{ directSale, isFetching, directSaleId, isAlerted, isLoading }}
    >
      {directSale && (
        <DirectSaleLGPDTermModal
          customerId={directSale?.customerId}
          open={lgpdOpen}
          onClose={setLgpdOpen.close}
          setAlert={setIsAlert}
        />
      )}
      {children}
    </DirectSaleContext.Provider>
  );
}
